import styled from 'styled-components';

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding: 8px 16px;
`;

export const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 4px;
  font-size: 14px;
`;

export const LegendLabel = styled.span`
  font-size: 18px;
  font-weight: 700;
`;
